import { render } from "./Teach.vue?vue&type=template&id=6464aee2"
import script from "./Teach.vue?vue&type=script&lang=js"
export * from "./Teach.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__